import React from 'react';
import { projectStateType } from 'types';
import {
  colors, Div, weight, Figure,
} from 'globalStyle';
import active from 'assets/icons/project-status-active.svg';
import closed from 'assets/icons/project-status-closed.svg';
import arrears from 'assets/icons/project-status-arrears.svg';
import moneyGive from 'assets/icons/project-status-money-give.svg';
import moneyReturned from 'assets/icons/project-status-money-returned.svg';
import pendingBond from 'assets/icons/project-status-pending-bond.svg';
import pendingCommission from 'assets/icons/project-status-pending-commission.svg';
import pendingPayment from 'assets/icons/project-status-pending-payment.svg';
import postponed from 'assets/icons/project-status-postponed.svg';
import preMoneyGive from 'assets/icons/project-status-pre-money-give.svg';
import confirmationAccept from 'assets/icons/project-status-confirmation-accept.svg';
import confirmationRejected from 'assets/icons/project-status-confirmation-rejected.svg';
import advertisingCampaign from 'assets/icons/project-status-advertising-campaign.svg';

import { TextLight } from 'components/Texts';

export const StatusCard = ({
  color, name, imageStatus, width = '200px', height = '70px',
}) => (
  <Div
    width={width}
    height={height}
    backgroundColor={color}
    p="10px 15px"
    radius="10px"
    isFlex
    justify="space-between"
  >
    <Div>
      <TextLight color={colors.WHITE} size={12}>
        Estado:
      </TextLight>
      <TextLight color={colors.WHITE} size={12} weight={weight.MEDIUM}>
        {name}
      </TextLight>
    </Div>

    <Figure width="43px" height="38px" color={colors.WHITE}>
      <img src={imageStatus} alt="estado del proyecto" />
    </Figure>
  </Div>
);

export function getStatusData(status) {
  switch (status) {
    case projectStateType.OPEN:
      return {
        imageStatus: active,
        nameStatus: 'Proyecto <br /> al aire',
        name: 'Proyecto al aire',
        color: `${colors.success}`,
      };
    case projectStateType.CLOSED:
      return {
        imageStatus: closed,
        nameStatus: 'Financiación <br /> finalizada',
        name: 'Financiación finalizada',
        color: `${colors.primary}`,
      };
    case projectStateType.POSTPONED:
      return {
        imageStatus: postponed,
        nameStatus: 'Proyecto <br /> en espera',
        name: 'Proyecto en espera',
        color: `${colors.secondary}`,
      };
    case projectStateType.MONEY_RETURNED:
      return {
        imageStatus: moneyReturned,
        nameStatus: 'Recursos <br/> en devolución',
        name: 'Recursos en devolución',
        color: `${colors.success}`,
      };
    case projectStateType.PENDING_PAYMENT:
      return {
        imageStatus: pendingPayment,
        nameStatus: 'Pago <br /> activo',
        name: 'Pago activo',
        color: `${colors.success}`,
      };
    case projectStateType.MONEY_GIVE:
      return {
        imageStatus: moneyGive,
        nameStatus: 'Recaudo <br /> de recursos',
        name: 'Recaudo de recursos',
        color: `${colors.secondary}`,
      };
    case projectStateType.COLLECTING:
      return {
        imageStatus: moneyGive,
        nameStatus: 'Desembolso <br /> de recursos',
        name: 'Desembolso de recursos',
        color: `${colors.secondary}`,
        textColor: colors.GRAY_1,
        iconFilter:
          'invert(41%) sepia(3%) saturate(6%) hue-rotate(326deg) brightness(91%) contrast(95%)',
      };
    case projectStateType.PRE_MONEY_GIVE:
      return {
        imageStatus: preMoneyGive,
        nameStatus: 'Meta <br /> alcanzada',
        name: 'Meta alcanzada',
        color: `${colors.success}`,
      };
    case projectStateType.PENDING_BOND:
      return {
        imageStatus: pendingBond,
        nameStatus: 'En proceso <br /> de emisión',
        name: 'En proceso de emisión',
        color: `${colors.secondary}`,
      };
    case projectStateType.PENDING_COMMISSION:
      return {
        imageStatus: pendingCommission,
        nameStatus: 'Traslado de <br /> recursos en proceso',
        name: 'Traslado de recursos en proceso',
        color: `${colors.secondary}`,
      };
    case projectStateType.LEGAL_REP_CONFIRMATION_ACCEPTED:
      return {
        imageStatus: confirmationAccept,
        nameStatus: 'Aceptado por  <br /> la empresa',
        name: 'Aceptado por la empresa',
        color: `${colors.success}`,
      };
    case projectStateType.LEGAL_REP_CONFIRMATION_REJECTED:
      return {
        imageStatus: confirmationRejected,
        nameStatus: 'Rechazado por  <br /> la empresa',
        name: 'Rechazado por la empresa',
        color: `${colors.GRAY_1}`,
      };
    case projectStateType.ARREARS:
      return {
        imageStatus: arrears,
        nameStatus: 'Pago <br /> pendiente',
        name: 'Pendiente de pago',
        color: `${colors.tertiary}`,
      };
    case projectStateType.ADVERTISING_CAMPAIGN:
      return {
        imageStatus: advertisingCampaign,
        nameStatus: 'Campaña <br /> publicitaria  ',
        name: 'Campaña publicitaria',
        color: `${colors.error}`,
      };
    case projectStateType.WAITING_LEGAL_REP_CONFIRMATION:
      return {
        imageStatus: advertisingCampaign,
        nameStatus: 'Pendiente de <br /> aprobación  ',
        name: 'Pendiente de aprobación',
        color: `${colors.secondary}`,
      };
    default:
      return { undefined, status };
  }
}
